/* Optional selector. Functional session state only; no personal text, email or cart writes. */
(() => {
  const init = root => {
    if (root.dataset.pgReady) return;
    root.dataset.pgReady = 'true';
    const pt = root.dataset.locale.startsWith('pt');
    // EN/FR/DE/IT/NL: textos desde locales (lpm_guide.js_*); ES y PT siguen con sus literales.
    const tr = (() => { const el = root.querySelector('[data-pg-i18n]'); if (!el) return null; try { return JSON.parse(el.textContent); } catch (e) { return null; } })();
    const finder = root.querySelector('[data-pg-finder]');
    const state = {recipient: '', meaning: '', step: 'recipient'};
    const progress = root.querySelector('[data-pg-progress]');
    const back = root.querySelector('[data-pg-back]');
    let viewed = false;
    const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
    function track(action, extra = {}) {
      if (!allowed()) return;
      const data = {guide_id: 'personalizables-v1', action, ...extra};
      // Supplemental events only. Purchase remains the campaign's bidding goal.
      window.Shopify?.analytics?.publish?.('lpm_personalization_guide', data);
      if (typeof window.gtag === 'function') window.gtag('event', 'lpm_presale_' + action, data);
    }
    function view() { if (!viewed && allowed()) { viewed = true; track('view'); } }
    function show(step) {
      state.step = step;
      finder.dataset.pgActive = step;
      root.querySelectorAll('[data-pg-step]').forEach(el => { el.hidden = el.dataset.pgStep !== step; });
      back.hidden = step === 'recipient';
      progress.textContent = step === 'recipient' ? '1 / 2' : step === 'meaning' ? '2 / 2' : (tr ? tr.selection : (pt ? 'A tua seleção' : 'Tu selección'));
      root.querySelector('[data-pg-step="' + step + '"] h3')?.focus({preventScroll: true});
    }
    const who = tr ? tr.who : pt ? {partner:'Para a vossa história.', family:'Para ter os teus por perto.', friend:'Para essa cumplicidade especial.', self:'Para o teu próprio significado.'} : {partner:'Para vuestra historia.', family:'Para llevar cerca a los tuyos.', friend:'Para esa complicidad especial.', self:'Para tu propio significado.'};
    const meaning = tr ? tr.meaning : pt ? {names:'Começa pelas joias com nomes gravados. A ficha indica quantos nomes aceita cada desenho.',cut:'As letras formam o desenho nestas peças de corte. Conta com 12-15 dias de fabricação, além do transporte.',date:'Explora peças para iniciais ou datas. Confirma os caracteres e opções disponíveis em cada ficha.'} : {names:'Empieza por las joyas con nombres grabados. La ficha indica cuántos nombres admite cada diseño.',cut:'Las letras forman el diseño en estas piezas de corte. Cuenta con 12-15 días de fabricación, además del transporte.',date:'Explora piezas para iniciales o fechas. Confirma los caracteres y opciones disponibles en cada ficha.'};
    const categories = [...root.querySelectorAll('[data-pg-category]')];
    let activeFilter = 'all';
    const expanded = new Set();
    const stateKey = 'lpm-guide-state-v1:' + root.dataset.locale;
    const save = () => { try { sessionStorage.setItem(stateKey, JSON.stringify({time:Date.now(), state, activeFilter, expanded:[...expanded], scroll:scrollY, hash:location.hash})); } catch {} };
    window.addEventListener('pagehide', save);
    root.addEventListener('click', () => queueMicrotask(save));
    const matches = card => activeFilter === 'all' || card.dataset.pgMeanings.split(' ').includes(activeFilter);
    function renderProducts() {
      let total = 0;
      categories.forEach(category => {
        const cards = [...category.querySelectorAll('[data-pg-product]')];
        const eligible = cards.filter(matches);
        const isExpanded = expanded.has(category.dataset.pgCategory);
        cards.forEach(card => { card.hidden = !matches(card) || (!isExpanded && eligible.indexOf(card) >= 8); });
        total += eligible.length;
        category.querySelector('[data-pg-empty]').hidden = eligible.length > 0;
        const more = category.querySelector('[data-pg-more]');
        more.hidden = eligible.length <= 8;
        more.setAttribute('aria-expanded', String(isExpanded));
        more.textContent = tr ? (isExpanded ? tr.less : tr.more_n.replace('{n}', eligible.length - 8)) : isExpanded ? (pt ? 'Ver menos' : 'Ver menos') : (pt ? 'Ver mais ' : 'Ver ') + (eligible.length - 8) + (pt ? ' desenhos' : ' diseños más');
      });
      root.querySelectorAll('[data-pg-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.pgFilter === activeFilter)));
      const labels = tr ? tr.labels : pt ? {all:'Todos os desenhos',names:'Nomes gravados',cut:'Nomes recortados',date:'Iniciais ou datas'} : {all:'Todos los diseños',names:'Nombres grabados',cut:'Nombres recortados',date:'Iniciales o fechas'};
      root.querySelector('[data-pg-filter-summary]').textContent = tr ? tr.summary.replace('{label}', labels[activeFilter]).replace('{n}', total) : labels[activeFilter] + ' · ' + total + (pt ? ' disponíveis, organizados por tipo de joia.' : ' disponibles, organizados por tipo de joya.');
    }
    function filterProducts(value) {
      activeFilter = ['names', 'cut', 'date'].includes(value) ? value : 'all';
      expanded.clear(); renderProducts();
    }
    function syncHash() {
      const value = location.hash.replace('#pg-', '');
      if (['names', 'cut', 'date'].includes(value)) filterProducts(value);
      else if (value === 'designs') filterProducts('all');
    }
    window.addEventListener('hashchange', syncHash);
    root.querySelector('[data-pg-filters]').hidden = false;
    let saved;
    try { saved = JSON.parse(sessionStorage.getItem(stateKey)); } catch {}
    if (saved && Date.now()-saved.time < 1800000 && saved.hash === location.hash) {
      if (['all','names','cut','date'].includes(saved.activeFilter)) activeFilter = saved.activeFilter;
      for (const value of saved.expanded || []) if (categories.some(category => category.dataset.pgCategory === value)) expanded.add(value);
      if (saved.state && ['recipient','meaning','result'].includes(saved.state.step)) {
        Object.assign(state, saved.state);
        if (state.step === 'result' && who[state.recipient] && meaning[state.meaning]) {
          root.querySelector('[data-pg-result-copy]').textContent = who[state.recipient] + ' ' + meaning[state.meaning];
          const hasProducts = categories.some(category => [...category.querySelectorAll('[data-pg-product]')].some(card => card.dataset.pgMeanings.split(' ').includes(state.meaning)));
          root.querySelector('[data-pg-result-link]').href = hasProducts ? '#pg-' + state.meaning : '#pg-designs';
        }
        root.querySelectorAll('[data-pg-recipient]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.pgRecipient === state.recipient)));
        root.querySelectorAll('[data-pg-meaning]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.pgMeaning === state.meaning)));
        show(state.step);
      }
      requestAnimationFrame(() => scrollTo({top:Number(saved.scroll)||0,behavior:'instant'}));
      renderProducts();
    } else { renderProducts(); syncHash(); }
    root.addEventListener('click', event => {
      const filter = event.target.closest('[data-pg-filter]');
      if (filter) { filterProducts(filter.dataset.pgFilter); track('filter', {family: activeFilter}); return; }
      const more = event.target.closest('[data-pg-more]');
      if (more) {
        const category = more.closest('[data-pg-category]');
        const key = category.dataset.pgCategory;
        const wasExpanded = expanded.has(key);
        if (wasExpanded) expanded.delete(key); else expanded.add(key);
        renderProducts();
        if (wasExpanded) category.scrollIntoView({block: 'start'});
        else {
          const firstNewCard = [...category.querySelectorAll('[data-pg-product]')].filter(matches)[8];
          firstNewCard?.focus({preventScroll: true});
          firstNewCard?.scrollIntoView({block: 'center'});
        }
        track('show_more', {category: key, expanded: !wasExpanded}); return;
      }
      const anchor = event.target.closest('a[href^="#pg-"]');
      if (anchor) {
        const value = anchor.hash.replace('#pg-', '');
        if (['names', 'cut', 'date'].includes(value)) filterProducts(value);
        else if (value === 'designs') filterProducts('all');
      }
      const recipient = event.target.closest('[data-pg-recipient]');
      if (recipient) {
        state.recipient = recipient.dataset.pgRecipient;
        root.querySelectorAll('[data-pg-recipient]').forEach(el => el.setAttribute('aria-pressed', String(el === recipient)));
        track('start', {recipient: state.recipient}); show('meaning'); return;
      }
      const choice = event.target.closest('[data-pg-meaning]');
      if (choice) {
        state.meaning = choice.dataset.pgMeaning;
        root.querySelectorAll('[data-pg-meaning]').forEach(el => el.setAttribute('aria-pressed', String(el === choice)));
        const hasProducts = categories.some(category => [...category.querySelectorAll('[data-pg-product]')].some(card => card.dataset.pgMeanings.split(' ').includes(state.meaning)));
        root.querySelector('[data-pg-result-copy]').textContent = who[state.recipient] + ' ' + meaning[state.meaning] + (!hasProducts ? (tr ? ' ' + tr.no_products : pt ? ' Consulta o catálogo para veres os desenhos disponíveis.' : ' Consulta el catálogo para ver los diseños disponibles.') : '');
        root.querySelector('[data-pg-result-link]').href = hasProducts ? '#pg-' + state.meaning : '#pg-designs';
        track('result', {recipient: state.recipient, family: state.meaning}); show('result'); return;
      }
      if (event.target.closest('[data-pg-back]')) { show(state.step === 'result' ? 'meaning' : 'recipient'); return; }
      if (event.target.closest('[data-pg-reset]')) { show('recipient'); return; }
      const product = event.target.closest('[data-pg-product]');
      if (product) track('product_click', {product_handle: product.dataset.pgProduct, family: activeFilter, category: product.dataset.pgCategoryLink});
    });
    finder.hidden = false;
    document.addEventListener('visitorConsentCollected', view);
    document.addEventListener('shopifyCustomerPrivacyApiLoaded', view);
    if (window.Shopify?.loadFeatures && !window.Shopify.customerPrivacy) window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], view);
    view();
  };
  document.querySelectorAll('[data-personalization-guide]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-personalization-guide]').forEach(init));
})();
